import classnames from 'classnames';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { onFileSelected } from 'v2/utils/fileUtils';
import uploadFileIconRedesign from '../../icons/uploadFileRedesign.svg';
import styles from './dataFileUploader.module.scss';

interface DataFileUploaderProps {
  onFileSelected: (file?: File | undefined) => void;
  className?: string;
}

const DataFileUploader = ({
  onFileSelected: _onFileSelected,
  className,
}: DataFileUploaderProps) => {
  const onDrop = useCallback(onFileSelected(_onFileSelected), [onFileSelected]);

  const onFileDialogCancel = () => {
    _onFileSelected();
  };

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    noKeyboard: true,
    onDrop,
    onFileDialogCancel,
  });

  return (
    <>
      <div
        {...getRootProps()}
        className={classnames(
          styles.uploadSection,
          'selectable',
          styles.redeign,
          className
        )}
      >
        <input {...getInputProps()} aria-label="inputDataFileSelectFile" />
        <img src={uploadFileIconRedesign} alt="uploadFileIcon" />
        <div className={styles.right}>
          <h1 className={styles.desktopHeader}>
            Drag and Drop files here, or <span>browse on your computer</span>
          </h1>
          <h1 className={styles.mobileHeader}>Tap here to upload files</h1>
          <p className={styles.limitText}>Maximum size 50mb</p>
        </div>
      </div>
    </>
  );
};

export default DataFileUploader;
